import React from 'react';
import { useStyletron } from 'baseui';
import { type OnChangeParams, Select, SIZE as SELECT_SIZE } from 'baseui/select';
import { useAtomValue, useSetAtom } from 'jotai';
import { RELATIONSHIP_CREATOR_CONSTANTS } from '../../../../../modernization-common/relationships/constants';
import { RELATIONSHIP_SELECT_OVERRIDES } from '../../../../../modernization-common/relationships/overrides';
import { dispatchAtom } from '../../../atoms/label-store-dispatch/dispatch';
import { EVENTS } from '../../../atoms/label-store-dispatch/events';
import { isSourceEditableAtom, sourceObjectIdAtom, validSourceAnnotationsAtom } from '../../../atoms/relationship-atoms';
import { allAnnotationMapAtom } from '../../../atoms/side-panel-atoms';
import { getAnnotationSelectLabel } from './annotation-select-label';
export const SourceSection = () => {
  const [css, theme] = useStyletron();
  const sourceId = useAtomValue(sourceObjectIdAtom);
  const isEditable = useAtomValue(isSourceEditableAtom);
  const allAnnotationsMap = useAtomValue(allAnnotationMapAtom);
  const validSources = useAtomValue(validSourceAnnotationsAtom);
  const dispatch = useSetAtom(dispatchAtom);
  const annotation = allAnnotationsMap[sourceId];
  const sourceDisplayOption = sourceId ? {
    id: sourceId,
    label: annotation ? `${annotation.annotation.annotationLabel.title}[${sourceId}]` : sourceId,
    annotationLabel: annotation?.annotation.annotationLabel
  } : null;
  const options = validSources.map(entry => ({
    id: entry.annotation.id,
    label: `${entry.annotation.annotationLabel.title}[${entry.annotation.id}]`,
    annotationLabel: entry.annotation.annotationLabel
  }));
  const handleOnChange = (params: OnChangeParams) => {
    const id = params.value[0]?.id?.toString() ?? '';
    dispatch({
      type: EVENTS.SELECT_RELATIONSHIP_SOURCE,
      annotationId: id
    });
    if (id) {
      dispatch({
        type: EVENTS.SELECT_ANNOTATION,
        annotationId: id
      });
    }
  };
  return <div className={css({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.sizing.scale300
  })}>
      <div className={css({
      ...theme.typography.LabelSmall,
      margin: 0
    })}>
        {RELATIONSHIP_CREATOR_CONSTANTS.SOURCE_LABEL}
      </div>
      {isEditable ? <Select size={SELECT_SIZE.compact} options={options} value={sourceDisplayOption ? [sourceDisplayOption] : []} onChange={handleOnChange} clearable={false} overrides={RELATIONSHIP_SELECT_OVERRIDES} getOptionLabel={getAnnotationSelectLabel} getValueLabel={getAnnotationSelectLabel} placeholder="Select source annotation" /> : <Select size={SELECT_SIZE.compact} options={sourceDisplayOption ? [sourceDisplayOption] : []} value={sourceDisplayOption ? [sourceDisplayOption] : []} disabled clearable={false} overrides={RELATIONSHIP_SELECT_OVERRIDES} getOptionLabel={getAnnotationSelectLabel} getValueLabel={getAnnotationSelectLabel} />}
    </div>;
};